module.exports = __webpack_public_path__ + "img/5.ef3b66f0.png";